import React, { useState, useContext, useEffect } from 'react';
import AssessmentDetails from '../../../../Components/MultipleAssessments/AssessmentDetails/AssessmentDetails';
import MatrixCompare from '../../../../Components/MultipleAssessments/MatrixCompare/MatrixCompare';
import HolySprit from '../../../../Assets/Images/holy-spirit.svg';
import Evangelization from '../../../../Assets/Images/evangelization.svg';
import leadership from '../../../../Assets/Images/leadership.svg';
import LanguageContext from '../../../../Store/LanguageContext';
import MultipleAssessmentsContext from '../../../../Store/MultipleAssessmentsContext';
import { translate } from '../../../../Components/translate/translate';
import ZeroState from '../../../../Components/MultipleAssessments/ZeroState/ZeroState';
import { useNavigate, useParams } from 'react-router-dom';
import DashboardContext from '../../../../Store/DashboardContext';
import Page404 from '../../../../Components/Page404/Page404';
import useWindowDimensions from '../../../../Hooks/useWindowDimensions';
import { preventWidow } from '../../../../utils/widowFix';

const DashboardMultiAssessmentCompare = () => {
  const { id } = useParams();
  const langCtx = useContext(LanguageContext);
  const multipleAssessmentsCtx = useContext(MultipleAssessmentsContext);
  const { deployments, isLoadingDeploymentInfo, is404Error, parishInsights, isLoadingParishInsights } = multipleAssessmentsCtx || {};
  const [currTab, setCurrTab] = useState(0);
  const dashboardCtx = useContext(DashboardContext);
  const navigate = useNavigate();
  const { windowWidth } = useWindowDimensions();
  const isMobile = windowWidth < 768;

  // Set assessment ID when component mounts or ID changes
  useEffect(() => {
    if (id) {
      multipleAssessmentsCtx.setAssessmentId(id);
    }
  }, [id, multipleAssessmentsCtx]);

  const handleTranslate = (text, type) => {
    switch (langCtx.language) {
      case "Nederlands": {
        return translate(text, "dashboardCompareDutch", type)
      }
      default: {
        return text;
      }
    }
  }

  const LoadingSpinner = () => (
    <div className="loading-container">
      <div className="spinner">
        <div className="spinner-inner"></div>
      </div>
      <p className="loading-text">{handleTranslate("Loading assessment data...", "loading-assessment-data")}</p>
    </div>
  );

  useEffect(() => {
    dashboardCtx.setDashboardId(id)
    // getParishInsights(id)
  }, [id])

  if (is404Error) {
    return (<Page404 />)
  }

  return (
    <div className="dashboard-multi-compare">
      <div className="overview-board">
        {/* <div className="overview-header">
          <a className="over-tab" onClick={() => { navigate(`/dashboard/${id}/overview?tab=parish`, { replace: true }); }}>
            {handleTranslate("My Parish", "my-parish")}
          </a>
          <a className="over-tab" onClick={() => { navigate(`/dashboard/${id}/overview?tab=leadership`, { replace: true }); }}>
            {handleTranslate("Leadership", "leadership")}
          </a>
          <a className="over-tab" onClick={() => { navigate(`/dashboard/${id}/overview?tab=parishioners`, { replace: true }); }}>
            {handleTranslate("Parishioners", "parishioners")}
          </a>
          <a className="over-tab" onClick={() => { navigate(`/dashboard/${id}/overview?tab=results`, { replace: true }); }}>
            {handleTranslate("My Results", "my-results")}
          </a>
        </div> */}
        <div>
          <div className="boxes">
            <p className='subtext'>{preventWidow(handleTranslate("See how your parish compares between any two assessments.", "see-compare-heading-info"))}</p>

            {(!isLoadingDeploymentInfo && Array.isArray(deployments) && deployments.length === 0) ? (
              <ZeroState route="Comparison" />
            ) : (
              <>
                <AssessmentDetails />
                {isLoadingParishInsights ? (
                  <LoadingSpinner />
                ) : (
                  parishInsights ? !(parishInsights?.[0]?.userCount === 0 || parishInsights?.[1]?.userCount === 0) ? (
                    <>
                      <div className='tabs'>
                        <div className={`tab ${currTab === 0 && 'active'}`} onClick={() => setCurrTab(0)}>
                          <img src={HolySprit} alt="" />
                          <div>
                            <span>{handleTranslate("Holy Spirit", "holy-spirit")}</span>
                          </div>
                        </div>
                        <div className={`tab ${currTab === 1 && 'active'}`} onClick={() => setCurrTab(1)}>
                          <img src={Evangelization} alt="" />
                          <div>
                            <span>{handleTranslate("Evangelization", "evangelization")}</span>
                          </div>
                        </div>
                        <div className={`tab ${currTab === 2 && 'active'}`} onClick={() => setCurrTab(2)}>
                          <img src={leadership} alt="" />
                          <div>
                            <span>{handleTranslate("Leadership", "leadership")}</span>
                          </div>
                        </div>
                      </div>

                      <div className="box-and-discover-parent">
                        <div className='box-matrix matrix' style={currTab === 0 ? { borderTopLeftRadius: "0px",paddingTop: "0px !important" } : { paddingTop: "0px !important" } }>
                          <div className='le-pa-container'>
                            <div style={{ display: "block" }} className='head'>
                              <div className='row'>
                                <div className='h-cell' style={{ width: '48%' }}></div>
                                <div className='h-cell'></div>
                                <div className='h-cell le-pa-container'>
                                  <div className='lp-container'>
                                    <p>{parishInsights?.[0]?.deploymentTitle.toUpperCase() || 'Unknown'}</p>
                                  </div>
                                </div>
                                <div className='h-cell le-pa-container'>
                                  <div className='lp-container'>
                                    <p>{parishInsights?.[1]?.deploymentTitle.toUpperCase() || 'Unknown'}</p>
                                  </div>
                                </div>
                                <div className='h-cell le-pa-container'>
                                  <div className='lp-container'>
                                    <p>{handleTranslate("% Change", "percent-change")}</p>
                                  </div>
                                </div>
                                <div className='h-cell' ></div>
                              </div>
                            </div>
                            {currTab === 0 && (
                              <>
                                <MatrixCompare collapsed={false} title={handleTranslate("Experience of the Holy Spirit", "experience-of-the-holy-spirit")} questionsPair={[
                                  parishInsights?.[0]?.areasOfExcellence?.find(a => a['Experience of the Holy Spirit'])?.['Experience of the Holy Spirit']?.[0]?.questions || [],
                                  parishInsights?.[1]?.areasOfExcellence?.find(a => a['Experience of the Holy Spirit'])?.['Experience of the Holy Spirit']?.[0]?.questions || []
                                ]} />
                                <MatrixCompare collapsed={true} title={handleTranslate("Asking & Discerning in Faith", "asking-and-discerning-in-faith")} questionsPair={[
                                  parishInsights?.[0]?.areasOfExcellence?.find(a => a['Asking & Discerning in Faith'])?.['Asking & Discerning in Faith']?.[0]?.questions || [],
                                  parishInsights?.[1]?.areasOfExcellence?.find(a => a['Asking & Discerning in Faith'])?.['Asking & Discerning in Faith']?.[0]?.questions || []
                                ]} />
                                <MatrixCompare collapsed={true} title={handleTranslate("Responding in Faith", "responding-in-faith")} questionsPair={[
                                  parishInsights?.[0]?.areasOfExcellence?.find(a => a['Responding in Faith'])?.['Responding in Faith']?.[0]?.questions || [],
                                  parishInsights?.[1]?.areasOfExcellence?.find(a => a['Responding in Faith'])?.['Responding in Faith']?.[0]?.questions || []
                                ]} />
                              </>
                            )}
                            {currTab === 1 && (
                              <>
                                <MatrixCompare collapsed={false} title={handleTranslate("Resources Aligned", "resources-aligned")} questionsPair={[
                                  parishInsights?.[0]?.areasOfExcellence?.find(a => a['Resources Aligned'])?.['Resources Aligned']?.[0]?.questions || [],
                                  parishInsights?.[1]?.areasOfExcellence?.find(a => a['Resources Aligned'])?.['Resources Aligned']?.[0]?.questions || []
                                ]} />
                                <MatrixCompare collapsed={true} title={handleTranslate("Primacy of Programs", "primacy-of-programs")} questionsPair={[
                                  parishInsights?.[0]?.areasOfExcellence?.find(a => a['Primacy of Programs'])?.['Primacy of Programs']?.[0]?.questions || [],
                                  parishInsights?.[1]?.areasOfExcellence?.find(a => a['Primacy of Programs'])?.['Primacy of Programs']?.[0]?.questions || []
                                ]} />
                                <MatrixCompare collapsed={true} title={handleTranslate("Cultural Reinforcement", isMobile? "cultural-reinforcement-mobile" : "cultural-reinforcement")} questionsPair={[
                                  parishInsights?.[0]?.areasOfExcellence?.find(a => a['Cultural Reinforcement'])?.['Cultural Reinforcement']?.[0]?.questions || [],
                                  parishInsights?.[1]?.areasOfExcellence?.find(a => a['Cultural Reinforcement'])?.['Cultural Reinforcement']?.[0]?.questions || []
                                ]} />
                              </>
                            )}
                            {currTab === 2 && (
                              <>
                                <MatrixCompare collapsed={false} title={handleTranslate("Vision", "vision")} questionsPair={[
                                  parishInsights?.[0]?.areasOfExcellence?.find(a => a['Vision'])?.['Vision']?.[0]?.questions || [],
                                  parishInsights?.[1]?.areasOfExcellence?.find(a => a['Vision'])?.['Vision']?.[0]?.questions || []
                                ]} />
                                <MatrixCompare collapsed={true} title={handleTranslate("Planning and Priorities", "planning-and-priorities")} questionsPair={[
                                  parishInsights?.[0]?.areasOfExcellence?.find(a => a['Planning and Priorities'])?.['Planning and Priorities']?.[0]?.questions || [],
                                  parishInsights?.[1]?.areasOfExcellence?.find(a => a['Planning and Priorities'])?.['Planning and Priorities']?.[0]?.questions || []
                                ]} />
                                <MatrixCompare collapsed={true} title={handleTranslate("Leading out of a team", "leading-out-of-a-team")} questionsPair={[
                                  parishInsights?.[0]?.areasOfExcellence?.find(a => a['Leading out of a team'])?.['Leading out of a team']?.[0]?.questions || [],
                                  parishInsights?.[1]?.areasOfExcellence?.find(a => a['Leading out of a team'])?.['Leading out of a team']?.[0]?.questions || []
                                ]} />
                                <MatrixCompare
                                  collapsed={true}
                                  title={handleTranslate('Growing Leadership Skills', isMobile ? 'growing-leadership-skills-mobile' : 'growing-leadership-skills')}
                                  questionsPair={[
                                    parishInsights?.[0]?.areasOfExcellence?.find(a => a['Growing Leadership Skills'])?.['Growing Leadership Skills']?.[0]?.questions || [],
                                    parishInsights?.[1]?.areasOfExcellence?.find(a => a['Growing Leadership Skills'])?.['Growing Leadership Skills']?.[0]?.questions || []
                                  ]}
                                />
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="no-data-container">
                      <p className="no-data-text">{handleTranslate("No data available", "no-data-available")}</p>
                    </div>
                  ) : <></>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default DashboardMultiAssessmentCompare
